import _toConsumableArray from "/codebuild/output/src3607656390/src/mdigital-online-morrisons.com-storefinder-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, _toConsumableArray(params));
  }
  return !!_useErrorBoundary;
}
export { shouldThrowError };